module.exports = "<div [ngStyle]=\"getDivStyle()\" id=\"up\">\r\n</div>\r\n"